import { useCallback, useState } from 'react';

export function resolveTraceOpen({
  userOverride,
  open,
  running,
}: {
  userOverride?: boolean;
  open?: boolean;
  running?: boolean;
}): boolean {
  if (userOverride !== undefined) {
    return userOverride;
  }

  if (open !== undefined) {
    return open;
  }

  return running ?? false;
}

export function useTraceOpen({
  open,
  running,
  initialUserOverride,
  onUserChange,
}: {
  open?: boolean;
  running?: boolean;
  initialUserOverride?: boolean;
  onUserChange?: (open: boolean) => void;
}): {
  isOpen: boolean;
  onOpenChange: (details: { open: boolean }) => void;
} {
  const [userOverride, setUserOverride] = useState<boolean | undefined>(
    initialUserOverride,
  );
  const isOpen = resolveTraceOpen({ userOverride, open, running });
  const onOpenChange = useCallback(
    ({ open: nextOpen }: { open: boolean }) => {
      setUserOverride(nextOpen);
      onUserChange?.(nextOpen);
    },
    [onUserChange],
  );

  return { isOpen, onOpenChange };
}
